import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuardService} from '../../core/auth/auth-guard.service';
import {ProjectResolver} from './project.resolver';
import {
  ProjectCreationPage,
  ProjectDetailsWrapperPage,
  ProjectListPage,
  ProjectMembersPage,
  ProjectPluginsPage,
  ProjectOverviewPage,
  ProjectPlayerDetailPage,
  ProjectPlayerListPage,
  ProjectSettingsPage
} from './pages';
import {ProjectBranchListPage} from './pages/project-branch-list/project-branch-list.page';
import {ProjectBranchDetailsPage} from './pages/project-branch-details/project-branch-details.page';
import {ProjectTransactionDetailsPage} from './pages/project-transaction-details/project-transaction-details.page';
import {ProjectAccessResolver} from './project-access.resolver';
import {ProjectActivityBuildsPage} from './pages/project-activity/project-activity-builds/project-activity-builds.page';
import {TelemetryDataPage} from '../telemetry/pages';
import {ProjectWebhookListPage} from './pages/project-webhook-list/project-webhook-list.page';
import {ProjectWebhookDetailsPage} from './pages/project-webhook-details/project-webhook-details.page';


const routes: Routes = [
  {
    path: 'project',
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    data: {roles: ['AC_MANAGE_PROJECT', 'AC_READ_PROJECT']},
    children: [
      {
        path: '',
        component: ProjectCreationPage,
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        data: {title: 'Project Creation', roles: ['AC_MANAGE_PROJECT']},
      },
      {
        path: 'list',
        component: ProjectListPage,
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        data: {title: 'Project Overview', roles: ['AC_MANAGE_PROJECT', 'AC_READ_PROJECT']}
      },
      {
        path: ':id',
        component: ProjectDetailsWrapperPage,
        data: {roles: ['AC_MANAGE_PROJECT', 'AC_READ_PROJECT']},
        resolve: {project: ProjectResolver, userProjectAccess: ProjectAccessResolver},
        children: [
          {path: '', redirectTo: 'overview', pathMatch: 'full'},
          {path: 'overview', component: ProjectOverviewPage, data: {title: 'Project Overview'}},
          {path: 'settings', component: ProjectSettingsPage, data: {title: 'Settings'}},
          {path: 'members', component: ProjectMembersPage, data: {title: 'Member Overview', roles: ['AC_MANAGE_PROJECT']}},
          {path: 'branch/list', component: ProjectBranchListPage, data: {title: 'Branch Overview'}},
          {path: 'branch/:id', component: ProjectBranchDetailsPage, data: {title: 'Branch Detail'}},
          {path: 'webhooks', component: ProjectWebhookListPage, data: {title: 'Webhook Overview'}},
          {path: 'webhook/:webhookId', component: ProjectWebhookDetailsPage, data: {title: 'Webhook'}},
          {path: 'webhook', component: ProjectWebhookDetailsPage, data: {title: 'Add Webhook'}},
          {path: 'plugins', component: ProjectPluginsPage, data: {title: 'Plugin Validation'}},
          {
            path: 'branch/:branchId/transaction/:transactionId',
            component: ProjectTransactionDetailsPage,
            data: {title: 'Branch Transaction Detail'}
          },
          {path: 'players', component: ProjectPlayerListPage, data: {title: 'Player Overview'}},
          {path: 'player/:id', component: ProjectPlayerDetailPage, data: {title: 'Player Detail'}},
          {path: 'telemetry', component: TelemetryDataPage, data: {title: 'Telemetry Data'}},
          {path: 'activity/build', component: ProjectActivityBuildsPage, data: {title: 'Build Overview', roles: ['AC_MANAGE_PROJECT']}}
        ]
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectRoutingModule {
}
